import {
  Box, ConditionalContent, DashboardModule, Image, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/pro-light-svg-icons'

import placeholderImageUrl from './assets/placeholder.svg'

interface LinkToEntityModuleProps {
  entityTitle: string,
  goToHref?: string,
  imageUrl?: string,
  loading: boolean,
  moduleTitle: string,
  secondaryText?: string,
}

const LinkToEntityModule = (props: LinkToEntityModuleProps) => {
  const {
    entityTitle, goToHref, imageUrl, loading, moduleTitle = 'Entity', secondaryText,
  } = props

  return (
    <DashboardModule loading={loading} title={moduleTitle}>
      <ConditionalContent visible={!loading}>
        <ListItem boxProps={{ borderBottom: '1px solid', padding: 'large', alignItems: 'center' }} disableHover>
          <Box
            border="1px solid"
            borderColor="lineColor"
            borderRadius={5}
            height={40}
            marginRight="large"
            padding="large"
            variant="center"
            width={60}
          >
            <Image
              backgroundSize="contain"
              // @ts-expect-error TS2322
              border="1px solid"
              borderColor="lineColor"
              borderRadius={5}
              placeholderUrl={placeholderImageUrl}
              url={imageUrl}
              height={40}
              width={60}
            />
          </Box>

          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">
              {entityTitle}
            </Text>

            {secondaryText && (
              <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
                {secondaryText}
              </Text>
            )}
          </Box>

          {goToHref && (
            <Link
              greyLink
              href={goToHref}
              textProps={{ marginLeft: 'medium' }}
            >
              <FontAwesomeIcon icon={faSignOut} />
            </Link>
          )}
        </ListItem>
      </ConditionalContent>
    </DashboardModule>
  )
}

export default LinkToEntityModule
